import { type RefObject, useEffect } from 'react'

type Handler = (event: MouseEvent) => void
type Options = {
  checkPopovers?: boolean
}

export function useClickOutside(
  refs: RefObject<HTMLElement | null>[],
  handler: Handler,
  options: Options = {},
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement

      const areRefsValid = refs.every((ref) => ref.current != null)
      if (!areRefsValid) return

      const wasClickOutside = refs.every((ref) => !ref.current?.contains(target))

      const isInPopover = options.checkPopovers
        ? target.closest('[data-radix-popper-content-wrapper]')
        : false

      if (wasClickOutside && !isInPopover) {
        handler(event)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refs, handler, options.checkPopovers])
}
